import { PrimaryCategoryKeys } from '@webapp/platform/organization-management/entities/enums/PrimaryCategoryKeys'

const primaryCategoryKey = 'primary-category'

export const primaryCategoryKeys = {
  all: [primaryCategoryKey],
  configList: [primaryCategoryKey, PrimaryCategoryKeys.CONFIG_LIST],
  configListUnfilteredCount: (active?: boolean) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_LIST,
    'unfiltered-count',
    active,
  ],
  configDetail: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
  ],
  secondaryCategories: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.SECONDARY_CATEGORIES,
  ],
  secondaryCategoriesUnfilteredCount: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.SECONDARY_CATEGORIES,
    'unfiltered-count',
  ],
  secondaryCategoryConfigDetail: (id: number) =>
    [primaryCategoryKey, 'secondary-category-config-detail', id] as const,
  configUsers: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.CONFIG_USERS,
  ],
}
